import { useQuery } from "@tanstack/react-query";
import {
  getScenarioListHistory,
  getScenarioHistory,
} from "../../api/history";

export const SCENARIO_LIST_HISTORY_KEY = ["scenarioListHistory"] as const;
export const SCENARIO_HISTORY_KEY = ["scenarioHistory"] as const;

export function useScenarioListHistory(modelId: number) {
  return useQuery({
    queryKey: [...SCENARIO_LIST_HISTORY_KEY, modelId],
    queryFn: () => getScenarioListHistory(modelId),
    enabled: modelId > 0,
    staleTime: 0,
  });
}

export function useScenarioHistory(
  modelId: number,
  scenarioId: number,
) {
  return useQuery({
    queryKey: [...SCENARIO_HISTORY_KEY, modelId, scenarioId],
    queryFn: () => getScenarioHistory(modelId, scenarioId),
    enabled: modelId > 0 && scenarioId > 0,
    staleTime: 0,
    select: (data) => {
      return data.map((row) => {
        const enriched = { ...row };
        if (row.details) {
          Object.entries(row.details).forEach(([k, v]) => {
            enriched[k] = v;
          });
        }
        return enriched;
      });
    },
  });
}
